
import React, { useReducer } from "react";
import axios2 from 'services/axios2';

import {useParams} from "react-router-dom";
import {Link,hashHistory} from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

import ImageUpload from "components/nubox/ImageUpload";
import NuConfirm from "components/nubox/Box/NuConfirm";
import NuInput from 'components/nubox/NuInput';
import NuListRadio from 'components/nubox/NuListRadio';
import ImageUploadSingle from "components/nubox/ImageUploadSingle";
import  NuDropdown from "components/nubox/NuDropdown"; 
import NuInputBox from "components/nubox/Box/NuInputBox";

import cApi from 'helpers/cApi'
import { withRouterJim } from "router/withRouterJim";

//--- CONTEXT API -----------
import { useStore, useDispatch, StoreContext } from "store/StoreProvider";
import {types, storeReducer} from "store/StoreReducer"

import { NotificationContainer, NotificationManager } from 'react-notifications';
import {
  Table,
  Button,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  ModalFooter,
  ToastHeader,
} from "reactstrap";

const cbo=[
  {  value:'1', label: 'label1'},
]


const initialForm = {
  idd:0,
  ope:'n',
  
  id_preins:'',
  fecha_reg:'', //2025-2-18
  id_peri:0, //2024
  periodo:'',
  extra_code:'',
  nro_doc:'',
  expedido:'BEN',
  ap_pat:'',
  ap_mat:'',
  nombres:'',
  sexo:0,
  fecha_naci:'',
  pais:'',
  departamento:'',
  provincia:'',
  localidad:'',
  zona:'',
  dir:'',
  tel:'',
  nro_diploma_ba:'',
  email:'',
  foto_path1:'',
  p_colegio:'',
  id_turno:0,
  p_turno:'MAÑANA',
  p_area:'URBANO',
  o_cargo:'',
  o_lugar:'',
  o_dir:'',
  estado:1, 
  id_carre:0,
  carrera:'',
};

//$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
class EstudianteP extends React.Component {
  state = {

    modalImagen: false,
    modalShow:false,
    
    form: Object.assign({}, initialForm),
    data: [],/* lista  */
    estados:[ { value:0, label: "Inactivo",color:"#da4a43"  },
      { value:1, label: "Activo", color:"#008ffb" },
    ],
    expedidos:[{ value:'BEN', label: "BEN" },
               { value:"CBB", label: "CBB" },
               { value:"CHQ", label: "CHQ" },
               { value:"LPZ", label: "LPZ" },
               { value:"ORU", label: "ORU" },
               { value:"OTRO", label: "OTRO" },
               { value:"PDO", label: "PDO" },
               { value:"PTO", label: "PTO" },
               { value:"SCZ", label: "SCZ" },
               { value:"TJA", label: "TJA" },
    ],
    sexos:[{ value:0, label: "FEMENINO" },
      { value:1, label: "MASCULINO" },
    ],
    arr_turnos:[{value:0, label:"MAÑANA"},
      {value:1, label:"TARDE"},
      {value:2, label:"VESPERTINO"},
    ],
    arr_areas:[{value:0, label:"URBANO"},
      {value:1, label:"RURAL"},
    ],
    arr_carr_preins:[],
    periodo_actual:{},
  };
   constructor(props) {
      super(props);
  
      this.refNuConfirm = React.createRef();
    }
    //------------------
  //---------------------------------
  componentDidMount() {
    //--limpiamos el array de prueba
    this.setState({data:[]});
    this.cargar_cbo_carrera_preins();
    this.cargar_periodo_actual();

    const date = new Date();
    const defaultValue = date.toLocaleDateString('en-CA');
  
    //this.setState({fecha: defaultValue}); 
    // Get the userId param from the URL.
    let idd = this.props.params.idd;
    let ope = this.props.params.ope;
    idd= cApi.decrypt(idd, 'eti')
    
    console.log("idd-->" + idd);
    console.log("ope-->" + ope);
    this.setState({ form:{...this.state.form, idd: idd, ope:ope, fecha_reg: defaultValue}}); 
    if(ope==='e' || ope==='x'){
      this.cargar_form(idd, ope);
    }

    
    //this.cargar_citas();
  }
  //----------------especial, actualiza valores del form -------------------------------
  handleChangeForm = (e) => {
    //requerimos la prop name='?' en cada control
    
    //--- esto lo hacemos porque en vez de utilizar valores true, false
    //--- tenemos que utilizar 1, 0
    if(e.target.type==="checkbox"){

      let res = e.target.checked? 1:0;        
      this.setState({
        form:{
          ...this.state.form,
          [e.target.name]: res,
        }
      })
    }else{
      this.setState({
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      });
    }
  };
  //----------------especial, actualiza valores del form -------------------------------
  handleChangeFormTurno = (e) => {
    //requerimos la prop name='?' en cada control
    console.log(e.target.item)

    this.setState({
      form: {
        ...this.state.form,
        id_turno: e.target.item.value,
        p_turno:  e.target.item.label,
      },
    });
  };
  //----------------especial, actualiza valores del form -------------------------------
  handleChangeFormArea = (e) => {
    //requerimos la prop name='?' en cada control
    console.log(e.target.item)

    this.setState({
      form: {
        ...this.state.form,
        id_area: e.target.item.value,
        p_area:  e.target.item.label,
      },
    });
  };
  handleChangeFormCarrera = (e) => {
    //requerimos la prop name='?' en cada control
    console.log(e.target.item)

    this.setState({
      form: {
        ...this.state.form,
        id_carrera: e.target.item.value,
        carrera:  e.target.item.label,
      },
    });
  };
   //---------------------------------------
  // id_carre, nombreca, descripca
  cargar_cbo_carrera_preins = () => {
    let param = { 
    }
    
    axios2.post("estudiante_p_cbo_carr_preins", param)
    .then(res => {
        this.setState({arr_carr_preins: res.data});
        this.setState({form:{...this.state.form, id_carre: res.data[0].value,
                        carrera: res.data[0].label,
        }});

    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
    });
  };
  //----------------------------
  // id_peri, peri
  cargar_periodo_actual = () => {
    let param = { 
    }
    
    axios2.post("estudiante_p_get_periodo_act", param)
    .then(res => {
      console.log(res.data)
      //this.setState({ periodo_actual: res.data });
      this.setState({ form:{...this.state.form, id_peri: res.data.id_peri, 
                                                periodo:res.data.peri }}); 
    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
    });
  };
  //---------------------------------------
  //-----------------------------------------
  cargar_form = (idd, ope) => {      

    let param = { 
      idd: idd,
      ope:'f'
    }
    console.log(param);
    axios2.post( "estudiante_p_store", param)
    .then(res => {
      
        if( res.data!==''){ 
            //añadimos el id y ope
            this.setState({
              form: {  ...res.data, 
                idd: idd,  
                ope: ope,
              },
            });
            
        }else{
          toast.error("Registro no encontrado", {
            position: toast.POSITION.TOP_RIGHT
          });
        }

    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
    });
  };
  
  //======================================================     
  imprimir =(id_preins)=>{

    let fileURL = process.env.REACT_APP_API_URL  + 'estudiante_p_pdf/'+ id_preins;
    let  windowFeatures = 'width=650,height= 700, left=100,top=100 ';
    window.open(fileURL,'',windowFeatures);
  }
  /******************************************** */
  //---buscamos los datos de un estudiante preinscrito
  buscarClick =()=>{
    console.log("buscar")
    this.setState({modalShow:true});
  }
  handleOK=(cad)=>{ 
    //e.preventDefault();
    console.log("cad="+cad)
    this.setState({ modalShow: false});
    
    //let fileURL = "/certificado1/"+ cad+"/e";
    //navigate(fileURL);
    //window.location= fileURL;
  }
  handleCancel=()=>{ 
    this.setState({ modalShow: false});
  }
   /************************************************ */
  
  // Toggle for Modal
  //-------------
  validar = () => {
    if(this.state.form.fecha_naci===""){
      toast.error("Fecha de nacimiento no valida");
      return false
    }
    if(this.state.form.nro_doc===""){
      toast.error("Nro de doc. no valido");
      return false
    }

    return true
  }
  //-----------------------------------------------
  aceptar_click = async () => {
    console.log("aceptar_click");
    
      this.refNuConfirm.current.show({
        message: 'Esta seguro de proceder?',
        title: 'Confirmación',
        icon: 'fa fa-question-circle',
        classHeader: 'bg-default1 ',
        classButton: 'btn btn-danger',
        accept: () => {
            this.save();
        },
        reject: () => {
            console.log('cancel');
        },
        acceptLabel: 'Aceptar',
        rejectLabel: 'Cancelar'
      })
  }
  //----------------------------
  save =() =>{    
    let ret =this.validar()
    if(!ret){
      //si hay error
      return
    }
      let param =  this.state.form;
      //param.id_rol= 1; //rol estudiante
      //param.idd=0;
      //param.ope='n';

      console.log(param);
      axios2.post("estudiante_p_store", param)
      .then(res => {
          console.log(res.data)
          if(res.data.exito === 1){ 
              toast.success(res.data.men);
              //--- tenemos que redireccionar
              //this.props.navigate('/EstudianteList');
              this.imprimir(res.data.id_preins)
          }else{
              toast.error(res.data.men);
          }
  
      }).catch(error => {
          alert("---- Existio un error ---");
          console.log(error);
          
      });
    
  }
  //------------------------------
  render() {
    return (
      <div>
        <div className="content">

        {/* ---   --- */}
        { 
          //JSON.stringify(this.state.form)
        }
        <section className="content-header text-center">
          <h3>
            {/*this.state.form.ope === 'n'
              ? "Nuevo "
              : "Editar "
              */
            }
            FORMULARIO DE PREINSCRIPCION <br/> NUEVOS ESTUDIANTES
          </h3>
        </section>

        <section className="content">

          <div className="card" style={{ backgroundColor: '#e1e4ea' }}>

            <div className="card-body">
              {/*-----*/}

              <form className="row" >
                
                {/*<!-- /.col -->*/}
                <div className='row'>
                    <div className='col-md-4'>
                        <label htmlFor='ap_pat' className=' control-label'><b>Cod. Preins.</b></label>
                        <br/>  
                        {this.state.form.id_preins}                        
                    </div>

                    <div className='col-md-4'>
                      <div className='form-group'>
                        <label htmlFor='ap_mat' className='control-label'><b>Gestión</b></label>    
                        <br/>
                        <label>
                          {this.state.form.periodo}
                        </label>
        
                      </div>
                    </div>
                    <div className='col-md-4'>
                      <div className='form-group'>
                        <label htmlFor='nombres' className=' control-label'><b>Cod. Registro</b></label>
                        <br/>
                        {this.state.form.extra_code}
                        
                        
                        {/*<Button onClick={ this.buscarClick } className=" btn btn-info ">
                          <i className="fa fa-find"></i> Buscar
                        </Button>*/}
                      </div>
                    </div>
                </div>

                {/*<!-- /.col -->*/}
                <div className='row'>
                    <div className='col-md-4'>
                        <label htmlFor='ap_pat' className='control-label'><b>Fecha de registro</b></label>
                          <br/>
                        <label>
                          {this.state.form.fecha_reg}
                        </label>
                        
                    </div>

                    <div className='col-md-4'>
                      
                    </div>
                    <div className='col-md-4'>
                      <div className='form-group'>
                        
                      </div>
                    </div>
                </div>

                <div className="col-md-12">

                  

              

              

                  <div className='top_title2'>
                    <h4 className=''>Datos Personales</h4>
                  </div>

                  

                  <div className='row'>
                    <div className='col-md-4'>
                        <label htmlFor='ap_pat' className='col-lg-3 control-label'><b>Paterno</b></label>
                          
                        <NuInput                        
                          className='form-control' 
                          type='text'
                          name='ap_pat' 
                          value={this.state.form.ap_pat}
                          onChange={this.handleChangeForm}
                          classOK=''
                          classError='is-invalid'
                          inputStyle={{textTransform: 'uppercase'}}
                          valtipo='string2'
                        />
                        
                    </div>
                    <div className='col-md-4'>
                      <div className='form-group'>
                        <label htmlFor='ap_mat' className='col-lg-3 control-label'><b>Materno</b></label>    
                        <NuInput                        
                          className='form-control' 
                          type='text'
                          name='ap_mat' 
                          value={this.state.form.ap_mat}
                          onChange={this.handleChangeForm}
                          classOK=''
                          classError='is-invalid'
                          inputStyle={{textTransform: 'uppercase'}}
                          valtipo='string2'
                        />
        
                      </div>
                    </div>
                    <div className='col-md-4'>
                      <div className='form-group'>
                        <label htmlFor='nombres' className='col-lg-3 control-label'><b>Nombres</b></label>
                        <NuInput
                            className='form-control'
                            type='text'
                            name='nombres'
                            value={this.state.form.nombres}
                            onChange={this.handleChangeForm}
                            classOK=''
                            classError='is-invalid'
                            inputStyle={{textTransform: 'uppercase'}}
                            valtipo='string2'
                          />
                      </div>
                    </div>
                  </div>

                  <div className='form-group row'>
                    
                    <div className='col-md-4'>
                      <label htmlFor='nro_doc' className='col-lg-3 control-label'><b>C.I.</b></label>
                      <NuInput                        
                        className=' form-control' 
                        type='text'
                        name='nro_doc' 
                        value={this.state.form.nro_doc}
                        onChange={this.handleChangeForm}
                        classOK=''
                        classError='is-invalid'
                        valtipo='string2'
                      />
                  
                    </div>

                    <div className='col-md-2'>
                      <label htmlFor='fecha_naci' className='control-label'><b>Expedido</b></label>
                        <NuDropdown
                            options={this.state.expedidos}
                            name="expedido"
                            value={this.state.form.expedido}
                            onChange={this.handleChangeForm}
                          />
        
                      
                    </div>
                    <div className='col-md-2'>
                      <label htmlFor='fecha_naci' className='control-label'><b>Sexo</b></label>
                      <NuDropdown
                            options={this.state.sexos}
                            name="sexo"
                            value={this.state.form.sexo}
                            onChange={this.handleChangeForm}
                          />
        
                      
                    </div>

                    <div className='col-md-4'>
                      <label htmlFor='fecha_naci' className='control-label'><b>Fecha Nacimiento</b></label>
                      <input
                        type='date'
                        name='fecha_naci'
                        value={this.state.form.fecha_naci}
                        onChange={this.handleChangeForm}
                        className='form-control'
                      />
        
                      
                    </div>
                  </div>
                  
                  

                  <div className='top_title2'>
                    <h4 className=''>Datos Procedecia</h4>
                  </div>


                  <div className='form-group row'>
                    
                    <div className='col-md-4'>
                      <label htmlFor='nro_doc' className='col-lg-3 control-label'><b>Pais</b></label>
                      <NuInput                        
                        className=' form-control' 
                        type='text'
                        name='pais' 
                        value={this.state.form.pais}
                        onChange={this.handleChangeForm}
                        classOK=''
                        classError='is-invalid'
                        valtipo='string2'
                      />
                  
                    </div>

                    <div className='col-md-4'>
                      <label htmlFor='fecha_naci' className='control-label'><b>Departamento</b></label>
                      <NuInput                        
                        className=' form-control' 
                        type='text'
                        name='departamento' 
                        value={this.state.form.departamento}
                        onChange={this.handleChangeForm}
                        classOK=''
                        classError='is-invalid'
                        valtipo='string2'
                      />
                    </div>
        
                    <div className='col-md-4'>
                      <label htmlFor='fecha_naci' className='control-label'><b>Provincia</b></label>
                      <NuInput                        
                        className=' form-control' 
                        type='text'
                        name='provincia' 
                        value={this.state.form.provincia}
                        onChange={this.handleChangeForm}
                        classOK=''
                        classError='is-invalid'
                        valtipo='string2'
                      />
                      
                    </div>
                  </div>

                  {/** */}

                  <div className='form-group row'>
                    
                    <div className='col-md-4'>
                      <label htmlFor='nro_doc' className='col-lg-3 control-label'><b>Localidad</b></label>
                      <NuInput                        
                        className=' form-control' 
                        type='text'
                        name='localidad' 
                        value={this.state.form.localidad}
                        onChange={this.handleChangeForm}
                        classOK=''
                        classError='is-invalid'
                        valtipo='string2'
                      />
                  
                    </div>

                    <div className='col-md-4'>
                      <label htmlFor='fecha_naci' className='control-label'><b>Zona</b></label>
                      <NuInput                        
                        className=' form-control' 
                        type='text'
                        name='zona' 
                        value={this.state.form.zona}
                        onChange={this.handleChangeForm}
                        classOK=''
                        classError='is-invalid'
                        valtipo='string2'
                      />
                    </div>
        
                    <div className='col-md-4'>
                      <label htmlFor='fecha_naci' className='control-label'><b>Dirección</b></label>
                      <NuInput                        
                        className=' form-control' 
                        type='text'
                        name='dir' 
                        value={this.state.form.dir}
                        onChange={this.handleChangeForm}
                        classOK=''
                        classError='is-invalid'
                        valtipo='string2'
                      />
                      
                    </div>
                  </div>

                  {/** */}

                  <div className='form-group row'>
                    
                    <div className='col-md-4'>
                      <label htmlFor='nro_doc' className='col-lg-3 control-label'><b>Telf.</b></label>
                      <NuInput                        
                        className=' form-control' 
                        type='text'
                        name='tel' 
                        value={this.state.form.tel}
                        onChange={this.handleChangeForm}
                        classOK=''
                        classError='is-invalid'
                        valtipo='string2'
                      />
                  
                    </div>

                    <div className='col-md-4'>
                      <label htmlFor='fecha_naci' className='control-label'><b>Nro Diploma Bachiller</b></label>
                      <NuInput                        
                        className=' form-control' 
                        type='text'
                        name='nro_diploma_ba' 
                        value={this.state.form.nro_diploma_ba}
                        onChange={this.handleChangeForm}
                        classOK=''
                        classError='is-invalid'
                        valtipo='string2'
                      />
                    </div>
        
                    <div className='col-md-4'>
                      
                      
                    </div>
                  </div>
                  {/** */}

                  <div className='top_title2'>
                    <h4 className=''>Datos Procedecia Educativa</h4>
                  </div>

                  <div className='form-group row'>
                    
                    <div className='col-md-4'>
                      <label htmlFor='nro_doc' className='col-lg-3 control-label'><b>Colegio</b></label>
                      <NuInput                        
                        className=' form-control' 
                        type='text'
                        name='p_colegio' 
                        value={this.state.form.p_colegio}
                        onChange={this.handleChangeForm}
                        classOK=''
                        classError='is-invalid'
                        valtipo='string2'
                      />
                  
                    </div>

                    <div className='col-md-4'>
                    <label htmlFor='fecha_naci' className='control-label'><b>Area</b></label>
                        <NuDropdown
                          options={this.state.arr_areas}
                          name="id_area"
                          value={this.state.form.id_area}
                          onChange={this.handleChangeFormArea}
                        />
                    </div>
        
                    <div className='col-md-4'>
                      
                      
                    </div>
                  </div>
                  
                  <div className='top_title2' >
                    <h4 className=''>Ocupación</h4>
                  </div>
                  {/** */}
                  {/** */}
                  <div className='form-group row'>
                    
                    <div className='col-md-4'>
                      <label htmlFor='nro_doc' className=' control-label'><b>Cargo que ocupa</b></label>
                      <NuInput                        
                        className=' form-control' 
                        type='text'
                        name='o_cargo' 
                        value={this.state.form.o_cargo}
                        onChange={this.handleChangeForm}
                        classOK=''
                        classError='is-invalid'
                        valtipo='string2'
                      />
                  
                    </div>
                    
                  </div>

                  <div className=' row'>
                      <div className='col-md-4'>
                        <label htmlFor='fecha_naci' className='control-label'><b>Institución de trabajo ó estudio</b></label>
                        <NuInput                        
                          className=' form-control' 
                          type='text'
                          name='o_lugar' 
                          value={this.state.form.o_lugar}
                          onChange={this.handleChangeForm}
                          classOK=''
                          classError='is-invalid'
                          valtipo='string2'
                        />
                      </div>
          
                      <div className='col-md-4'>
                        <label htmlFor='fecha_naci' className='control-label'><b>Domicilio del trabajo ó estudio</b></label>
                        <NuInput                        
                          className=' form-control' 
                          type='text'
                          name='o_dir' 
                          value={this.state.form.o_dir}
                          onChange={this.handleChangeForm}
                          classOK=''
                          classError='is-invalid'
                          valtipo='string2'
                        />
                        
                      </div>
                    </div>
                  {/** */}
                  
                  
                  <div className='top_title mt-2' style={{ color: '#c83030', borderBottom: '3px solid #c4858b' }}>
                    <h4 className=''>Carrera a inscribir</h4>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <div className='form-group'>
                            <label htmlFor='ap_mat' className='col-lg-3 control-label'><b>CARRERA</b></label>    
                            <NuDropdown
                                options={this.state.arr_carr_preins}
                                name="id_carre"
                                value={this.state.form.id_carre}
                                onChange={this.handleChangeFormCarrera}
                                style={{backgroundColor: 'white'}}
                              />
                      </div>
                    </div>

                    <div className="col-md-4">
                    <label htmlFor='fecha_naci' className='control-label'><b>Turno</b></label>
                        <NuDropdown
                              options={this.state.arr_turnos}
                              name="id_turno"
                              value={this.state.form.id_turno}
                              onChange={this.handleChangeFormTurno}
                            />
                    </div>
                  </div>


                  {/*<div className='form-group row'>
                   <label htmlFor='password' className='col-lg-3 control-label'><b>Estado</b></label>
                    <div className='col-lg-9'>

                      <NuListRadio
                        options={this.state.estados}
                        name="estado"
                        value={this.state.form.estado}
                        onChange={this.handleChangeForm}
                        isHorizontal={true}
                      />

                    </div>
                  </div>
                  */} 

                  

                </div>
              </form>

            </div>

            <div className="card-footer">
              <div className="form-group">
                <div className="text-center">
                  <Button onClick={this.aceptar_click} className="btn btn-danger">
                    <i className="fa fa-floppy-o"></i>&nbsp;
                    Guardar e imprimir
                  </Button>
                  
                  &nbsp;
                  &nbsp;
                  <Link to='/estudiante_preins' className="btn btn-default">Cancelar</Link>
                </div>
              </div>
            </div>

          </div>

        </section>
        </div>
      

        <NuInputBox modalShow={ this.state.modalShow } 
                  titulo="Entrada" 
                  mensaje="Introduzca número de certificado" 
                  handleOK={ this.handleOK } 
                  handleCancel={ this.handleCancel } />
        <ToastContainer />
        <NuConfirm   ref={ this.refNuConfirm }    />
      </div>
    );
  }
}
  
//------------para que soporte la funcionalidad de parametros
export default withRouterJim(EstudianteP);
